module.exports = __webpack_public_path__ + "img/124.d8be3a74.png";